import { Box } from '@mui/material';
// components
import MyAvatar from '../../../components/MyAvatar';

// ----------------------------------------------------------------------

export default function AccountPopover() {
  return (
    <Box sx={{ p: 0 }}>
      <MyAvatar />
    </Box>
  );
}
